import {Component} from "react";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import {Button, ButtonGroup, Form, Input, InputGroup, InputGroupText, Label} from "reactstrap";
import PerimetersList from "../../../ComponentParts/Perimeters/PerimetersList.mjs";
import CheckIcon from "../../../media/images/CheckIcon.mjs";
import Glob from "../../../libs/Glob.mjs";
import UserIcon from "../../../media/images/UserIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import MySelect from "../../../controls/MySelect.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import SearchIcon from "../../../media/images/SearchIcon.mjs";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import ChevronLeftIcon from "../../../media/images/ChevronLeftIcon.mjs";
import AppWarningIcon from "../../../media/app-images/AppWarningIcon.mjs";
import AppReloadIcon from "../../../media/app-images/AppReloadIcon.mjs";

const prefix = 'SimulationFlowInfo';

const PeriPicker = class extends Component {
	render() {
		return (
			<div className="PeriPicker">
				<h5 className={"options-label"}>
					<span>
						<TextLabel value={"Perimeter"} />
					</span>
					{ (typeof this.props.close === 'function') && (
						<ButtonGroup>
							<Button
								onClick={this.props.close}
							>
								<TextLabel value={"Cancel"} />
							</Button>
						</ButtonGroup>
					) }
				</h5>
				<PerimetersList
					selected={this.props.selected}
					onClick={ this.props.save }
					filter={ list => list.filter( p => !! p.finalized )}
					clickIcon={ <CheckIcon style={{fill:"#090"}}/> }
				/>
			</div>
		)
	}
}

const SimulationFlowInfo = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isNew: true,
			didRun: false,
			didSettings: false,
			changed: false,
			canSave: false,
			/** @type {HorusSimulationObject} */
			saved: props.saved || {},
			peri: props.peri,
			/** @type {HorusSimulationObject} */
			simul: props.simul
		}
		if ( this.state.saved.status ) {
			this.state.didRun = (this.state.saved.status >= 50);
			this.state.didSettings = (this.state.saved.status > 10);
			this.state.isNew = false;
		}
		this.uid = Glob.generateUid(prefix);
		this.setValue = this.setValue.bind(this);
		this.setOption = this.setOption.bind(this);
		this.canSave = this.canSave.bind(this);
		this.save = this.save.bind(this);
	}
	canSave() {
		let s = true;
		if ( ! (this.state.simul.info?.name||'').trim() ) s = false;
		if ( ! this.state.simul.info?.peri ) s = false;
		this.setState({canSave: s, changed: true });
	}
	save() {
		//await this.props.save( Glob.clone(this.state.simul) );
		const RestEntryPoint = this.state.simul?.id ? "simul/info" : "simul/create";
		const payload = { simul: structuredClone(this.state.simul) };
		if ( payload.simul.fake &&  payload.simul.info ) payload.simul.info.fake = true;
		appLib.api( RestEntryPoint, payload ).then( (res)=>{
			this.setState({ canSave: false, changed: false }, ()=>{
				const cp = Glob.getCurrentPage();
				if ( cp.name === 'SimulationFlowNew' && res.id ) {
					setTimeout( ()=>{
						Glob.gotoPage({ name: "SimulationFlowEdit", params:{simul:res.id,step:Glob.getPageParam('step')}})
					});
				} else {
					this.props.afterSave(res);
				}
			});
		}).catch( err => { console.warn(payload, err ); });
	}
	setValue(e) {
		const s = this.state.simul;
		s.info[e.target.name] = e.target.value;
		this.setState({ simul: s }, this.canSave);
	}
	setOption(field, option) {
		const s = this.state.simul;
		s.info[field] = option?.value;
		this.setState({ simul: s }, this.canSave);
	}
	render() {
		return(
			<>
				<div className={"panel-content limited "+prefix} id={this.uid}>
					<h3>
						<TextLabel value={"Info"} />
					</h3>
					<Form
						onSubmit={ e => {
							e.preventDefault();
						}}
					>
						<InputGroup>
							<InputGroupText>
								<Label>
									<UserIcon />
								</Label>
							</InputGroupText>
							<InputGroupText>
								{ appLib.getUsername() }
							</InputGroupText>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Simulation type"} />:
								</Label>
							</InputGroupText>
							<div>
								<MySelect
									isDisabled={ this.state.didSettings }
									options={this.props.lists.types}
									value={ this.props.lists.types.find( s => s.value === this.state.simul.info?.type) }
									onChange={ opt => { this.setOption("type",opt); } }
								/>
							</div>
						</InputGroup>
						{ (this.state.pickPeri || ! this.state.simul.info?.peri)  ? (
							<PeriPicker
								selected={ this.state.simul.info?.peri }
								close={ this.state.simul.info?.peri ? ()=>{ this.setState({pickPeri:false})} : undefined}
								save={ peri => {
									const d = this.state.simul;
									d.info.peri = peri.id;
									d.fake = !! peri.fake;
									d.info.periname = peri.name;
									this.setState( { simul:d, pickPeri:false }, this.canSave );
								}}
							/>
						) : (
							<InputGroup>
								<InputGroupText>
									{ (!! this.state.simul.info?.peri) && (
										<span style={{marginRight:"auto"}}>
										{this.state.simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon />}
									</span>
									)}
									<Label>
										<TextLabel value={"Perimeter"} />:
									</Label>
								</InputGroupText>
								<Input
									type="text"
									readOnly={true}
									value={ this.state.simul.info?.periname || this.state.simul.info?.peri || '' }
								/>
								{ (! this.state.didSettings ) && (
									<Button onClick={ ()=>{ this.setState({pickPeri:true})} }>
										<SearchIcon />
									</Button>
								)}
							</InputGroup>
						)}
						<InputGroup className="input-group">
							<InputGroupText>
								<Label>
									<TextLabel value={"Name"} />:
								</Label>
							</InputGroupText>
							<Input
								type="text"
								name="name"
								value={this.state.simul.info?.name||''}
								onChange={ this.setValue }
							/>
						</InputGroup>
						<h5 className={"options-label"}>
						<span>
							<TextLabel value={"Options"} />
						</span>
						</h5>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Description"} />:
								</Label>
							</InputGroupText>
							<Input
								type="textarea"
								name="description"
								rows={2}
								value={this.state.simul.info?.description||''}
								onChange={ this.setValue }
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Cycle"} />:
								</Label>
							</InputGroupText>
							<div>
								<MySelect
									menuPlacement={"top"}
									isDisabled={ this.state.didRun }
									options={this.props.lists.cycles}
									value={ this.props.lists.cycles.find( s => s.value === this.state.simul.info?.cycle) }
									onChange={ opt => { this.setOption("cycle",opt); } }
								/>
							</div>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Priority"} />:
								</Label>
							</InputGroupText>
							<div>
								<MySelect
									menuPlacement={"top"}
									isDisabled={ this.state.didRun }
									options={this.props.lists.priorities}
									value={ this.props.lists.priorities.find( s => s.value === this.state.simul.info?.priority) }
									onChange={ opt => { this.setOption("priority",opt); } }
								/>
							</div>
						</InputGroup>
					</Form>
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup className={"btn-icon"}>
						<Button
							hidden={ ! this.props.editing }
							color="success"
							onClick={ ()=>{ Glob.rmCurrentPageParam('step')} }
						>
							<i>
								<ChevronLeftIcon />
							</i>
							<b>
								<TextLabel value={"Overview"} />
							</b>
						</Button>
						<Button
							hidden={ ! this.state.saved.id || ! this.state.changed }
							color={"warning"}
							onClick={ ()=>{
								this.setState( {
									simul: Glob.clone(this.state.saved),
									peri: Glob.clone(this.props.peri),
									canSave: false, changed: false
								});
							}}
						>
							<b>
								<TextLabel value={"Cancel"} />
							</b>
							<i>
								<AppReloadIcon />
							</i>
						</Button>
					</ButtonGroup>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"primary"}
							disabled={ ! this.state.canSave }
							onClick={ this.save }
						>
							<i>
								<CheckIcon />
							</i>
							<b>
								<TextLabel value={"Save"} />
							</b>
						</Button>
						<Button
							disabled={ ! this.state.simul?.id }
							color={"success"}
							onClick={ ()=>{
								Glob.setCurrentPageParam('step', 'settings');
							}}
						>
							<b>
								<TextLabel value={"Settings"} />
							</b>
							<i>
								{ (this.state.simul?.id && this.state.changed) ? <AppWarningIcon /> : <ChevronRightIcon /> }
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		)
	}
}

export default SimulationFlowInfo;